import styled from "styled-components/macro";

export const ActionLink = styled.a`
  cursor: pointer;

  :disabled {
    cursor: not-allowed;
  }
`;

export const ActionButton = styled.button`
  cursor: pointer;
`;

export default styled.input``;
